export const stringTableFetcher = (locale)=>{
    return import(/* webpackChunkName: "InformationProtectionStrings" */ `./translations/${locale}/InformationProtectionStrings.json`);
};
